import {RootStore} from './RootStore';
import { observable, action, reaction } from 'mobx';
import agent from '../api/agent';


export default class CommonStore {
    rootStore: RootStore;
    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
    }

    @action getInstitution = async (emplid: string) => {
        const list = this.getResponseInstitution(emplid);
        return list;
    };

    getResponseInstitution  = async (emplid: string)  => {
        const list = await agent.Common.institution(emplid);
        const result = list.result;
        let data = new Array();
        for (let res of result) {
            const label = {label: res.DESCR, value: res.CODE};
            data.push(label);
        }
        return data;
    };

    @action getInstitutionAuto = async (emplid: string) => {
        const list = this.getResponseInstitutionAuto(emplid);
        return list;
    };

    getResponseInstitutionAuto  = async (emplid: string)  => {
        // emplid = 'E072442'
        const list = await agent.Common.institutionAuto(emplid);

        if(!list.count){
            return false;
        }
        else if(list.count == 1){
            return list.result
        }
        else{
            let data = new Array();
            for (let res of list.result) {
                const label = {label: res.DESCR, value: res.CODE};
                data.push(label);
            }
            return data;
        }
        
    };

    @action getCareer = async (emplid: string, institution: string) => {
        const list = this.getResponseCareer(emplid, institution);
        return list;
    };

    getResponseCareer  = async (emplid: string, institution: string)  => {
        const list = await agent.Common.career(emplid, institution);
        const result = list.result;
        let data = new Array();
        for (let res of result) {
            const label = {label: res.DESCR, value: res.CODE};
            data.push(label);
        }
        return data;
    };

    @action getCareerAuto = async (emplid: string, institution:string) => {
        const list = this.getResponseCareerAuto(emplid,institution);
        return list;
    };

    getResponseCareerAuto  = async (emplid: string, institution:string)  => {
        // emplid = 'E023917'
        const list = await agent.Common.careerAuto(emplid,institution);
        if(list.count == 1){
            return list.result
        }
        else{
            let data = new Array();
            for (let res of list.result) {
                const label = {label: res.DESCR, value: res.CODE};
                data.push(label);
            }
            return data;
        }
        
    };

    @action getProgramByInstitution = async  (emplid: string, institution: string, career: string) => {
        const list = this.getResponseProgramByInstitution(emplid, institution, career);
        return list;
    };

    getResponseProgramByInstitution  = async (emplid: string, institution: string, career: string)  => {
        const list = await agent.Common.programByInstitution(emplid, institution, career);
        const result = list.result;
        let data = new Array();
        for (let res of result) {
            const label = {label: res.DESCR, value: res.CODE};
            data.push(label);
        }
        return data;
    };

    @action getSemester= async (institution: string, career: string) => {
        const list = this.getResponseSemester(institution, career);
        return list;
    };

    getResponseSemester  = async (institution: string, career: string)  => {
        const list = await agent.Common.semester(institution, career);
        const result = list.result;
        let data = new Array();
        for (let res of result) {
            const label = {label: res.DESCR, value: res.CODE};
            data.push(label);
        }
        return data;
    };

    @action getSemester2 = async (institution: string, career: string) => {
        const list = this.getResponseSemester2(institution, career);
        return list;
    };

    getResponseSemester2  = async (institution: string, career: string)  => {
        const list = await agent.Common.semester2(institution, career);
        const result = list.result;
        let data = new Array();
        for (let res of result) {
            const label = {label: res.DESCR, value: res.CODE};
            data.push(label);
        }
        return data;
    };

    @action getSemesterLatest= async (institution: string, career: string) => {
        const list = this.getResponseSemesterLatest(institution, career);
        return list;
    };

    getResponseSemesterLatest  = async (institution: string, career: string)  => {
        const list = await agent.Common.semesterLatest(institution, career);
        const result = list.result;
        let data = new Array();
        for (let res of result) {
            const label = {label: res.DESCR, value: res.CODE};
            data.push(label);
        }
        return data;
    };

    @action getSemesterLatestAuto= async (institution: string, career: string) => {
        const list = this.getResponseSemesterLatestAuto(institution, career);
        return list;
    };

    getResponseSemesterLatestAuto  = async (institution: string, career: string)  => {
        const list = await agent.Common.semesterLatestAuto(institution, career);
        const result = list.result;
        return result;
    };

    @action getSemesterWithNext= async (institution: string, career: string) => {
        const list = this.getResponseSemesterWithNext(institution, career);
        return list;
    };

    getResponseSemesterWithNext  = async (institution: string, career: string)  => {
        const list = await agent.Common.semesterNext(institution, career);
        const result = list.result;
        let data = new Array();
        for (let res of result) {
            const label = {label: res.DESCR, value: res.CODE};
            data.push(label);
        }
        return data;
    };

    @action getSemesterCheckUas= async (institution: string, career: string) => {
        const list = this.getResponseSemesterCheckUas(institution, career);
        return list;
    };

    getResponseSemesterCheckUas  = async (institution: string, career: string)  => {
        const list = await agent.Common.semesterCheckUas(institution, career);
        const result = list.result;
        let data = new Array();
        for (let res of result) {
            const label = {label: res.DESCR, value: res.CODE};
            data.push(label);
        }
        return data;
    };


    @action dashboard = async (level: string, emplid: string) => {
        try 
        {   
            const list = await agent.Common.dashboard(level, emplid);
            return list.result;
        } catch (error) {
            throw error;
        }
    };

    @action studentresponse = async (code: string, response: number) => {
        try 
        {   
            const list = await agent.Common.studentresponse(code, response);
            return list;
        } catch (error) {
            throw error;
        }
    };
}